import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { OiqUiDropdownComponent } from '@oiq-ui/dropdown.component';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { OiqLayoutService } from '../layout.service';

@Component({
  selector: 'oiq-layout-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    OiqUiDropdownComponent,
  ],
  host: {
    class: 'oiq-layout-search',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OiqLayoutSearchComponent {
  public layout = inject(OiqLayoutService);
  public cdr = inject(ChangeDetectorRef);

  searchSubject$ = new Subject<string>();

  @Output() searched = new EventEmitter<string>();

  @ViewChild('dropdownRef')
  dropdownRef: OiqUiDropdownComponent;

  constructor() {
    this.searchSubject$.pipe(debounceTime(300), distinctUntilChanged()).subscribe(value => {
      this.searched.emit(value);
    });

    this.layout.isSmall$.subscribe(isSmall => {
      if (!this.dropdownRef) {
        return;
      }
      if (!isSmall) {
        this.dropdownRef.close();
        this.cdr.markForCheck();
      }
    });
  }
}
